
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ico-academy",
      function () {
        return require("private-next-pages/ico-academy/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ico-academy"])
      });
    }
  